import React from "react";

const Button = ({
  type = "button",
  onClick,
  disabled = false,
  loading = false,
  loadingText,
  children,
  className,
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={className}
      {...props}
    >
      {loading ? loadingText || "Loading…" : children}
    </button>
  );
};

export default Button;
